export default {
  errorDefault: 'Ilmnes viga',
  unknown: 'Tundmatu',
};
